export type {
  TeachingPopoverCarouselCardProps,
  TeachingPopoverCarouselCardSlots,
  TeachingPopoverCarouselCardState,
} from '@fluentui/react-teaching-popover';
